import { render } from "./Jobs.vue?vue&type=template&id=1dd97be8&scoped=true"
import script from "./Jobs.vue?vue&type=script&lang=js"
export * from "./Jobs.vue?vue&type=script&lang=js"

import "./Jobs.vue?vue&type=style&index=0&id=1dd97be8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd97be8"]])

export default __exports__